import Extension from "../base/extension";

/**
 * Support extension for the QuickView custom element
 * 
 * @see {@link file://./../elements/quick-view.js}
 * @see {@link file://./../../sections/quick-view.liquid}
 * @see {@link file://./../../../snippets/modal-quick-view.liquid}
 */
class QuickView extends Extension {

  static #attached = false;

  init() {
    if (QuickView.#attached) return;
    document.body.addEventListener("click", this.#onClick);
    QuickView.#attached = true;

    document.addEventListener("cart:changed", () => {
      this.close();
    });
  }

  #onClick = e => {
    const btn = e.target.closest("[data-qv-initialise]");
    if (!btn) return;

    e.preventDefault();

    const handle = btn.dataset.qvInitialise?.trim();
    if (!handle) return;

    const sectionId = btn.dataset.qvSectionId; // optional
    this.open(handle, { sectionId });
  };

  open(handle, { sectionId } = {}) {
    const el = document.querySelector("quick-view");
    if (!el) {
      console.warn(this.logPrefix, "Quick View element not found. Does the section exist in 'Overlay group'?");
      return;
    };

    if (sectionId) el.setAttribute("section-id", sectionId);
    el.setAttribute("handle", handle);

    const modalEl = document.getElementById("quickViewModal");
    if (!modalEl) return;

    console.log(this.logPrefix, "Opening QuickView for handle:", handle, "sectionId:", sectionId);

    bootstrap.Modal.getOrCreateInstance(modalEl).show();
  }

  close() {
    const modalEl = document.getElementById("quickViewModal");
    if (!modalEl) return;
    
    console.log(this.logPrefix, "Closing");
    bootstrap.Modal.getOrCreateInstance(modalEl).hide();
  }
}

export default QuickView;